var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-inner"},[_c('a',{staticClass:"footer-link",attrs:{"href":"https://www.symbiocenter.com/assets/Mentions_legales.pdf","target":"_blank"}},[_vm._v(" Mentions légales ")]),_c('a',{staticClass:"footer-link",attrs:{"href":"https://www.symbiofi.com","target":"_blank"}},[_vm._v(" Centre de formation ")])])])
}]

export { render, staticRenderFns }